/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Conversion_Error_Source_File_UnavailableInputs */

const en_conversion_error_source_file_unavailable = /** @type {(inputs: Conversion_Error_Source_File_UnavailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This file is no longer available in ${i?.provider}. Check that it still exists and that you have access to it.`)
};

const es_conversion_error_source_file_unavailable = /** @type {(inputs: Conversion_Error_Source_File_UnavailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este archivo ya no está disponible en ${i?.provider}. Comprueba que todavía existe y que tienes acceso a él.`)
};

/**
* | output |
* | --- |
* | "This file is no longer available in {provider}. Check that it still exists and that you have access to it." |
*
* @param {Conversion_Error_Source_File_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_source_file_unavailable = /** @type {((inputs: Conversion_Error_Source_File_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Source_File_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_source_file_unavailable(inputs)
	return en_conversion_error_source_file_unavailable(inputs)
});